import React, { useState } from "react";
import { Picture, Accordion } from "components/UI";
import styled from "@emotion/styled";
import {
  gfxConsultationApply,
  gfxConsultationApproval,
  gfxConsultationFollowUp,
  gfxConsultationZoom,
} from "assets";
import { INSTRUCTIONS } from "./instructions";

const IMAGES = {
  0: gfxConsultationApply,
  1: gfxConsultationApproval,
  2: gfxConsultationZoom,
  3: gfxConsultationFollowUp,
};

const BG_HEIGHT = 850;

const Background = styled.div`
  height: ${BG_HEIGHT}px;
  clip-path: polygon(0 0%, 100% 0%, 100% 88%, 0% 100%);
`;

const SectionContainer = styled.section`
  margin-top: -${BG_HEIGHT}px;
`;

const HowItWorks = () => {
  const [activePanel, setPanel] = useState(0);

  return (
    <>
      <Background className="bg-lily" />
      <SectionContainer className="mb-12 sm:mb-24 relative">
        <h2 className="text-center mb-4 sm:mb-8 font-semibold">How It Works</h2>
        <div className="container m-auto px-4 text-center sm:w-3/4">
          GLP Consultants are experienced professionals who have driven successful campaigns and
          initiatives globally. Clients are provided with the necessary CONTEXT to make informed
          decisions, as well as CONNECTIONS to individuals and businesses who can support their
          goals.
        </div>
      </SectionContainer>
    </>
  );
};

export default HowItWorks;
